<template>
  <div class="qrcode-generator">
    <el-row>
      <el-col :span="12" :offset="6">
        <el-form :model="formData" label-width="80px">
          <el-form-item label="文本内容">
            <el-input
              type="textarea"
              v-model="formData.content"
              placeholder="请输入要生成二维码的文本内容"
              :rows="4"
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="generateQRCode">生成二维码</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row v-if="qrCode">
      <el-col :span="12" :offset="6">
        <div class="qrcode-result">
          <div><span class="label">二维码：</span></div>
          <div v-loading="loading"><img :src="qrCode" alt="二维码" ></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        content: ''
      },
      qrCode: '',
	  loading:true
    };
  },
  methods: {
    generateQRCode() {
		if(this.formData.content==""){
			this.$notify({
				title: '消息提示',
				message: "二维码内容不要为空！",
				type: 'error'
			});
			return
		}
      // 模拟生成二维码的操作，可以使用第三方库或者后端接口实现
      // 在这里假设生成二维码的方法名为 generateQRCodeFunction
	  this.loading=true
 this.$api.generateQrCode({content:this.formData.content}).then(res=>{
	 
	if(res.data.code==200){
		this.qrCode=res.data.data
	}else{
		this.$notify({
			title: '消息提示',
			message: res.data.msg,
			type: 'error'
		});
	}
	
		  this.loading=false
 })
    }
  }
};
</script>

<style scoped>
.qrcode-generator {
  padding: 20px;
}

.qrcode-result {
  margin-top: 20px;
  text-align: center;
}

.qrcode-result .label {
  font-weight: bold;
}
</style>